import React from 'react'
import { createBrowserHistory } from 'history'
import { StateProvider } from '@State'
import { Toaster } from '@CommonComponents/toast'
import { TemplateTables } from './TemplateTables'

export const history = createBrowserHistory()

export const App = ({ badgeDesigns, badges, certDesigns, certificates }) => {
  const initialState = {
    badgeDesigns: badgeDesigns,
    badges: badges,
    certificateDesigns: certDesigns,
    certificates: certificates,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'updateCerts':
        return {
          ...state,
          certificates: action.payload,
        }
      case 'updateBadges':
        return {
          ...state,
          badges: action.payload,
        }
    }
  }

  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Toaster />
      <TemplateTables />
    </StateProvider>
  )
}
